<template>

<div v-if="data" class="contentWrapper" v-bind:style="{ width: settings.width+'%' }">

    <div class="prop-wrap">

        <div :class="[{'bordered':  settings.isBordered }, 'prop-inner']">

            <!-- TITLE -->
            <h1 class="title" v-if="contentElementData[0]">{{ contentElementData[0].value }}</h1>

            <!-- IMAGE -->
            <template v-if="contentElementData[1] && contentElementData[1].assets.length > 0">
                <div class="recipeImage is-pulled-left ">
                    <img class="lazy-img-fadein img" v-lazy="$config.assets + contentElementData[1].assets[0].asset.path + '/' + contentElementData[1].assets[0].asset.filename" />
                </div>
            </template>

            <!-- ZUTATEN -->
            <div class="recipeIngredients" v-if="contentElementData[2]" v-html="contentElementData[2].value"></div>

            <!-- ZUBEREITUNG -->
            <div class="recipePreparation" v-if="contentElementData[3]" v-html="contentElementData[3].value"></div>

            <!-- TIPP -->
            <template v-if="contentElementData[4] && contentElementData[4].value != ''">
                <div class="recipeTippHeadline">{{ contentElementData[4].value }}</div>
                <div class="recipeTipp">{{ contentElementData[5].value }}</div>
            </template>

        </div>

    </div>

</div>

</template>



<script>

export default {

    props: ['data', 'settings'],

    data(){
		return {
            contentElementData: []
		}
	},

    created() {
        this.contentElementData = this.data.contentElement.contentElementData;
    },

    mounted() {
        // console.log(this.data);
    },

}

</script>



<style scoped>

.recipeIngredients {
    margin: 0 0 5% 0;
}
.recipePreparation {
    margin: 0 0 5% 0;
}

.recipeImage {
    max-width: 35%;
    margin: 0 2% 0 0;
}
.recipeImage img {
    width: 100%;
    height: auto;
}
.recipeTippHeadline {
    margin: 0 0 2% 0;
    font-weight: 500;
}
.recipeTipp {

}

</style>
